import "./components";
import "./utilities";
// import './icons/icons__config'; // icon font import
import './sprites';

/* Favicons entry point for webpack
 * html_code.html as expected output from realfavicongenerator.net
 * manually insert `WEBPACKHACK` to content attribute of meta[name="msapplication-config"] i.e.
 * <meta name="msapplication-config" WEBPACKHACKcontent="./browserconfig.xml">
 */
require('./favicons/html_code.html');



// WEBPACK FOOTER //
// ./project/client/src/site__pol/index.js